import * as React from 'react'

/**
 * @param {React.SVGProps<SVGSVGElement>} props
 * @returns {React.ReactElement}
 */
function SvgGlyphSmallTick (props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <path d="M44.39 66.09L32.74 54.44l3.92-3.92 7.73 7.73 19.36-19.36 3.92 3.92z" />
    </svg>
  )
}

export default SvgGlyphSmallTick
